(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jlf-article-news-products"] && !Shopify.designMode) return;
  try {
    
  function initJlfArticleNews(root = document) {
    root.querySelectorAll('[data-jlf-article-news]').forEach((section) => {
      if (section.dataset.jlfArticleNewsReady === 'true') return;

      const viewport = section.querySelector('[data-jlf-news-viewport]');
      const prev = section.querySelector('[data-jlf-news-prev]');
      const next = section.querySelector('[data-jlf-news-next]');

      const scroll = (direction) => {
        if (!viewport || window.matchMedia('(max-width: 749px)').matches) return;

        const card = section.querySelector('.jlf-article-news-card');
        const gap = 4;
        const amount = card ? card.getBoundingClientRect().width + gap : viewport.clientWidth;

        viewport.scrollBy({
          left: amount * direction,
          behavior: 'smooth',
        });
      };

      prev?.addEventListener('click', () => scroll(-1));
      next?.addEventListener('click', () => scroll(1));
      section.dataset.jlfArticleNewsReady = 'true';
    });
  }

  initJlfArticleNews();
  document.addEventListener('shopify:section:load', (event) => initJlfArticleNews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
